import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { ProductRatingsSectionComponent } from '../../../app/content/modules/page/components/product/components/product-ratings-section/product-ratings-section.component';
import { Rating } from '../../../app/core/interfaces/generated/graphql';
import { withCommonDecorators } from '../../_utils/story-helpers';
import { createDamilanoBarberaProduct } from '../../_mocks/wine-product.mock';

// Mock ratings data matching live site format
const mockRatings: Rating[] = [
  {
    __typename: 'Rating',
    id: '1',
    isPreviousVintage: false,
    label: '95/100',
    rating: 95,
    ratingPoint: '95',
    maxRatingSymbols: '100',
    starCount: 5,
    name: 'Vinonyme',
    review: 'Her har vi fat i en Brunello, lavet under andet label, af en topproducent som jeg godt tør sige har styr på sit håndværk. Nøøøj - hvor smager det fuldstændig fremragende.',
    reviewSnippet: 'Her har vi fat i en Brunello...',
    reviewer: {
      __typename: 'Reviewer',
      id: 'rev-1',
      title: 'Vinonyme',
      ratingType: 'points',
    },
  },
  {
    __typename: 'Rating',
    id: '2',
    isPreviousVintage: false,
    label: '94/100',
    rating: 94,
    ratingPoint: '94',
    maxRatingSymbols: '100',
    starCount: 5,
    name: 'Houlberg',
    review: 'I glasset er vinen forholdsvis lys og medium transparent med denne lidt murstensrøde kant. Smagen er også ret elegant … overraskende elegant endda.',
    reviewSnippet: 'I glasset er vinen forholdsvis lys...',
    reviewer: {
      __typename: 'Reviewer',
      id: 'rev-2',
      title: 'Houlberg',
      ratingType: 'points',
    },
  },
  {
    __typename: 'Rating',
    id: '3',
    isPreviousVintage: false,
    label: '94/100',
    rating: 94,
    ratingPoint: '94',
    maxRatingSymbols: '100',
    starCount: 5,
    name: 'Flaskehalsen',
    review: 'Det kunne være en røverhistorie, men kvaliteten afslører, at der sagtens kan være noget om snakken, for det er saftig, knastør og klassisk Sangiovese.',
    reviewSnippet: 'Det kunne være en røverhistorie...',
    reviewer: {
      __typename: 'Reviewer',
      id: 'rev-3',
      title: 'Flaskehalsen',
      ratingType: 'points',
    },
  },
];

const meta: Meta<ProductRatingsSectionComponent> = {
  title: 'Organisms/Product/ProductRatingsSection',
  component: ProductRatingsSectionComponent,
  decorators: [...withCommonDecorators()],
  parameters: {
    docs: {
      description: {
        component: 'Section displaying product ratings and reviews in a carousel format.',
      },
    },
    layout: 'padded',
  },
  argTypes: {
    product: {
      description: 'The wine product with ratings data',
    },
    toggleReadMore: {
      action: 'toggleReadMore',
      description: 'Event emitted when read more is toggled',
    },
  },
};

export default meta;
type Story = StoryObj<ProductRatingsSectionComponent>;

export const Default: Story = {
  args: {
    product: createDamilanoBarberaProduct(),
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-ratings-section')).toBeTruthy();
  },
};

export const SingleRating: Story = {
  args: {
    product: createDamilanoBarberaProduct({
      meta: {
        ratings: [mockRatings[0]],
      } as any,
    }),
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-ratings-section')).toBeTruthy();
  },
};

export const NoRatings: Story = {
  args: {
    product: createDamilanoBarberaProduct({
      meta: {
        ratings: [],
      } as any,
    }),
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-ratings-section')).toBeTruthy();
  },
};
